import React, { useState, useRef } from 'react';
import './WhoImageSlider.css';

// Импортируем изображения
import Card1 from './media/Card1.png';
import Card2 from './media/Card2.png';
import Card3 from './media/Card3.png';

const WhoImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  // Используем импортированные изображения
  const images = [Card1, Card2, Card3];

  // Размеры согласно требованиям
  const slideWidth = 276;
  const slideHeight = 332;
  const gap = 16;
  const containerWidth = 336;
  const sliderWidth = images.length * (slideWidth + gap) - gap;

  // Обработчики событий для свайпа
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX.current - touchEndX.current > 50) {
      // Свайп влево - следующий слайд
      setCurrentIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    } else if (touchEndX.current - touchStartX.current > 50) {
      // Свайп вправо - предыдущий слайд
      setCurrentIndex((prevIndex) => 
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
    }
  };

  return (
    <div style={{ position: 'relative', marginBottom: '120px' }}>
      {/* Текстовый компонент */}
      <div className="WhoTextComponent">
        <span className="WhoTextBlack">Динамика </span>
        <span className="WhoTextBlue">идеально</span>
        <span className="WhoTextBlack"> подойдет</span>
      </div>
      
      {/* Слайдер */}
      <div className="WhoSliderContainer" style={{ width: `${containerWidth}px`, height: `${slideHeight}px` }}>
        <div 
          className="WhoSlider"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          style={{ 
            transform: `translateX(-${currentIndex * (slideWidth + gap)}px)`,
            width: `${sliderWidth}px`
          }}
        >
          {images.map((image, index) => (
            <div 
              key={index} 
              className="WhoSlide"
              style={{ 
                width: `${slideWidth}px`,
                height: `${slideHeight}px`,
                marginRight: index < images.length - 1 ? `${gap}px` : '0'
              }}
            >
              <img 
                src={image} 
                alt={`Card ${index + 1}`} 
                className="WhoSlideImage"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhoImageSlider;